import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { SpaceBetween, Alert } from '@cloudscape-design/components';
import UploadSection from './UploadSection.jsx';
import ResultsSection from './ResultsSection.jsx';
import './image-link-generator.css';

export default function ImageLinkGenerator() {
  const navigate = useNavigate();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [error, setError] = useState('');

  const handleUploadComplete = () => {
    setRefreshTrigger(prev => prev + 1);
    setError('');
  };

  return (
    <div className="image-link-generator-page">
      <div className="linkg-container">
        {/* Breadcrumb — navigates back to the SmartBiz Toolkit home via
            react-router-dom so it stays an SPA transition. Rendered as a
            real <a href> via <Link> so right-click → Open in new tab works. */}
        <Link
          to="/"
          className="linkg-back-link"
          aria-label="Back to SmartBiz Toolkit"
        >
          ← Back to SmartBiz Toolkit
        </Link>
        {/* Hero banner */}
        <div className="linkg-hero">
          <div className="linkg-hero-icon">🔗</div>
          <div className="linkg-hero-text">
            <h1 className="linkg-hero-title">Image Link Generator</h1>
            <p className="linkg-hero-subtitle">Bulk upload images and generate permanent public URLs</p>
            <div className="linkg-hero-status">
              <span className="linkg-status-dot"></span>
              <span>Ready to upload</span>
              <span className="linkg-status-sep">|</span>
              <span>JPG, PNG, GIF, WebP, BMP, TIFF, SVG</span>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="linkg-content">
          <SpaceBetween size="l">
            {error && <Alert type="error" dismissible onDismiss={() => setError('')}>{error}</Alert>}
            <UploadSection onUploadComplete={handleUploadComplete} />
            <ResultsSection refreshTrigger={refreshTrigger} />
          </SpaceBetween>
        </div>
      </div>
    </div>
  );
}
